import React, { Component, useEffect, useState } from 'react';
import Opener from './platform/opener.jsx';
import Consent from './platform/consent.jsx';
import General from './platform/general.jsx';
import Test from './platform/test.jsx';
import Overview from './platform/overview.jsx';
import ThankYou from './platform/thankyou.jsx'
import * as d3 from "d3";

function Evaluation (props) {
    
    const session = props.session;
    
    const [step, setStep] = useState(3)
    const [participant, setParticipant] = useState('ID_' + Math.floor(10 + Math.random() * 90) + '-' + Math.floor(1000 + Math.random() * 9000))

    function updateStep(div, step) {
        d3.select(div).style('filter', 'blur(0) opacity(1)').transition().duration(1000).style('filter', 'blur(20px) opacity(0)')
        setTimeout(() => setStep(step), 1000)
    }

    useEffect(() => {
    })

    return (
        <div id="evaluation">
            {step === 0 && (<Opener 
                updateStep = {updateStep}
            />)}
            {step === 1 && (<Consent
                updateStep = {updateStep}
            />)}
            {step === 2 && (<General
                setStep = {setStep}
                participant = {participant}
                session = {session}
            />)}
            {step === 3 && (<Test 
                updateStep = {updateStep}
                participant = {participant}
                session = {session}
            />)}
            {step === 4 && (<Overview />)}
            {/* {step === 4 && (<ThankYou />)} */}
        </div>
    )
}

export default Evaluation;